import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import ModalActionButton from '../../elements/ModalActionButton'
import TextareaField from '../../elements/form/TextareaField'
import TextField from '../../elements/form/TextField'
import { updateTrait, clearCreatedTrait } from '../../../store/actions/traitsActions'

const EditTrait = ({close, trait, reload}) => {
    const [traitPayload, setTraitPayload] = React.useState(trait || {})
    const [validationErrors, setValidationErrors] = React.useState({})
    const traitsSelector = useSelector(state => state.traits)
    const dispatch = useDispatch()

    useEffect(() => {
        if(traitsSelector.createdTrait !== null) {
            reload()
            dispatch(clearCreatedTrait())
            setTimeout(() => {
                close()
            }, 50);
        }
        return () => {
            
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [traitsSelector.createdTrait, dispatch]);

    const validateForm = () => {
        let errors = {}
        if(!traitPayload.name || traitPayload.name === '') {
            errors.name = true
        }
        if(!traitPayload.description || traitPayload.description === '') {
            errors.description = true
        }

        setValidationErrors(errors)

        return errors
    }
    const pushTrait = () => {
        const errors = validateForm()
        if(Object.values(errors).includes(true)) {
            return
        }
        dispatch(updateTrait(traitPayload))
    }
    return (
        <div className="w-full">
            <p className='text-sm text-gray-500'>Please provide details of the trait in the fields below.</p>
            <div className='mt-4'>
                <TextField
                    inputLabel="Trait name" 
                    fieldId="trait-name" 
                    inputType="text" 
                    inputPlaceholder="Enter trait name (eg: Leadership, Teamwork, etc.)"
                    requiredField={true}
                    preloadValue={traitPayload.name || ''}
                    hasError={validationErrors && validationErrors.name} 
                    returnFieldValue={(value)=>{setTraitPayload({...traitPayload, ...{name: value}})}}
                />
            </div>

            <div className='my-2 w-full'>
                <TextareaField
                    inputLabel="Description" 
                    fieldId="status-note" 
                    inputType="text" 
                    inputPlaceholder="Enter trait description"
                    requiredField={false}
                    preloadValue={traitPayload.description || ''}
                    hasError={validationErrors.description} 
                    maxLength={300}
                    returnFieldValue={(value)=>{setTraitPayload({...traitPayload, ...{description: value}})}}
                />
                {traitPayload?.description?.length === 300 &&<p className='text-red-600 text-xs mt-2'>Please keep the description less than 300 characters</p>}
            </div>

            <div className="mt-8 flex flex-row-reverse gap-x-4">
                <ModalActionButton
                    buttonLabel={`Create Trait`}
                    buttonAction={()=>{pushTrait()}}
                    processing={traitsSelector.creatingTrait}
                />

                <button
                    type="button"
                    className="inline-flex justify-center px-5 py-4 text-xs font-medium bg-transparent border border-transparent rounded-md hover:bg-opacity-50 hover:bg-secondary focus:outline-none"
                    onClick={close}
                >
                    Cancel
                </button>
                
            </div>
        </div>
    )
}

export default EditTrait